import script from "./ScheduleManagement.vue?vue&type=script&setup=true&lang=js"
export * from "./ScheduleManagement.vue?vue&type=script&setup=true&lang=js"

import "./ScheduleManagement.vue?vue&type=style&index=0&id=0831558c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0831558c"]])

export default __exports__